import React, { Component } from 'react';
import IconButton from '../../../comum/components/IconButton';
import {ExcelExport, ExcelExportColumn} from "@progress/kendo-react-excel-export";
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import moment from 'moment';

@observer
export default class ExportarExcelDirecionamento extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller
    }

    _exporter;
    export = () => {
        this._exporter.save();
    };

    render() {
        let lista = toJS(this.controller.listaDirecionamentos)
        const colunas = this.controller.colunasExportar;

        if(lista.length > 0){
            lista.map(data => {
                const keys = Object.keys(data);
                keys.map(key =>{
                    if((key.includes('DtImport') || key.includes('DtCancel')) && moment(data[key]).format("DD/MM/YYYY HH:mm") !== 'Invalid date')
                        data[key] = moment(data[key]).format("DD/MM/YYYY HH:mm")
                })
            })
        }

        return (
            <div>
                <IconButton
                    icon="file-excel"
                    text="Baixar XLS"
                    size="md"
                    disabled={this.controller.listaDirecionamentos.length === 0}
                    onClick={this.export}
                />
                <ExcelExport
                    data={lista}
                    fileName="Direcionamento.xlsx"
                    ref={(exporter) => { this._exporter = exporter; }} >
                    { colunas.map((coluna, index) => (
                        <ExcelExportColumn
                            key={index}
                            title={coluna.text}
                            field={coluna.dataField}
                        />
                    )) }
                </ExcelExport>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/direcionamento/tecon/components/ExportarExcelDirecionamento.js